import { FC } from "react";
import { useTranslation } from "react-i18next";
import MarketSlide from "../../resources/components/MarketSlide";
import { currentYear, marketsArrayDE, marketsArrayFR } from "../../../Config";
import languageServiceFactory from "../../../services/LanguageServiceImpl";
import MarketsSlider from "../../resources/components/MarketsSlider";

const languageService = languageServiceFactory();

const MarketsSection: FC = () => {
    const { t } = useTranslation();

    return (
        <div
            id="markets"
            className="relative bg-[#F8F8F8] flex justify-center items-center py-[110px] dmax2:py-[60px] tmax4:!pb-[127px]"
        >
            <div className="relative mx-auto dmin2:w-[1280px] di8:w-[1138px] di7:w-[960px] ti3:w-[860px] td8:w-[767px] ti7:w-[600px] ti8:w-[500px] mi2:w-[440px] mi1:w-[360px] mi5:w-[320px]">
                <div className="w-[550px] mt5:w-[360px] mi5:w-[320px] mb-[50px] dmax2:mb-[30px]">
                    <h2 className="H24B mr-5">{t("marketsSection.title", { value: currentYear }).toUpperCase()}</h2>
                    <p className="H20 dmax2:H16 text-[#848484] mt-4">{t("marketsSection.text1")}</p>
                </div>
                <MarketsSlider>
                    {(languageService.isGerman ? marketsArrayDE : marketsArrayFR).map((market, index) => (
                        <MarketSlide key={`market-${index}`} index={index} market={market} />
                    ))}
                </MarketsSlider>
            </div>
        </div>
    );
};

export default MarketsSection;
